import { useQuery } from 'react-query';
import { authFetch } from '../../../CommonUtils/authFetch';
import { urlWithParams } from '../../../CommonUtils/urlWithParams';
import { queryKeys } from './queryKeys';
import { useRouteParams } from '../hooks/useRouteParams';

export interface AgreementDTO {
  id: string;
  name: string;
  url: string;
  accepted: boolean;
}

const fetchAutomatedAccountsAgreements = (clientId: string): Promise<AgreementDTO[]> =>
  authFetch(
    urlWithParams('/Consumer/AutomatedAccounts/Agreements', {
      clientId,
    }),
  );

export const useAutoAccountAgreementsQuery = () => {
  const { clientId } = useRouteParams();

  return useQuery(
    queryKeys.AutoAccountAgreement(clientId),
    () => fetchAutomatedAccountsAgreements(clientId),
    { cacheTime: 0 },
  );
};
